import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { CollapsePayload, UserSettingsResponse } from '../../../types/User';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const updateUserCollapse = async (formData: CollapsePayload): Promise<UserSettingsResponse> => {
  const response = await CustomAxios.put(`user-collapse`, formData);
  const { data } = response;
  return data;
};

export function useUpdateUserCollapse() {
  return useMutation({
    mutationFn: (formData: CollapsePayload) => updateUserCollapse(formData),
    onSuccess: () => {
      // fetch the user collapse again after update
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentUserSettings] });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data: UserSettingsResponse = err.response.data as UserSettingsResponse;
        queryClient.setQueryData([queryKeys.currentUserSettings], data);
      }
    },
  });
}
